<section class="messenger-input-group__container flex row justify-content-between align-start">
  <app-add-picture-button class="add-picture-button"></app-add-picture-button>
  <app-messenger-input
    class="messenger-input__container"
    (focus)="inputFocus()"
    (blur)="inputBlur()"
  ></app-messenger-input>
</section>
